import { 
  ActionCreatorWithoutPayload, 
  ActionCreatorWithPayload, 
  EntityAdapter, 
  EntityId, 
  EntityState, 
  Slice,
  Update,
} from "@reduxjs/toolkit";
import { RootState } from ".";

export type EntityWithId<H extends string> = {
  [P in H]: EntityId
} 


export abstract class StoreReducerFactory<ReducerName extends string, H extends string, V extends EntityWithId<H>> {
  protected entityAdapter: EntityAdapter<V, EntityId>;
  protected reducerSlice: Slice<EntityState<V, EntityId>>;
  protected reducerBase: String;

  constructor(protected readonly reducerName: ReducerName, protected readonly idKey: H, reducerBase: String = "optionsState", _initialize: (reducerName: ReducerName,idKey: H) => {entityAdapter: EntityAdapter<V, EntityId>, reducerSlice: Slice<EntityState<V,EntityId>>} = this.initialize) {
    const {entityAdapter: optionsEntityAdapter, reducerSlice: optionsSlice} = _initialize(reducerName, idKey);
    this.entityAdapter = optionsEntityAdapter;
    this.reducerSlice = optionsSlice
    this.reducerBase = reducerBase;
  }
  
  protected abstract initialize(reducerName: ReducerName,idKey: H) : {entityAdapter: EntityAdapter<V, EntityId>, reducerSlice: Slice<EntityState<V,EntityId>>}

  public get clear(): ActionCreatorWithoutPayload<`${ReducerName}/clear`> {
    return this.reducerSlice.actions.clear as ActionCreatorWithoutPayload<`${ReducerName}/clear`>;
  }

  public get updateMany(): ActionCreatorWithPayload<readonly Update<V, EntityId>[], `${ReducerName}/update`> {
   return this.reducerSlice.actions.updateMany as ActionCreatorWithPayload<readonly Update<V, EntityId>[], `${ReducerName}/update`> 
  }

  public get upsert(): ActionCreatorWithPayload<V[], `${ReducerName}/upsert`> {
    return this.reducerSlice.actions.upsert as ActionCreatorWithPayload<V[], `${ReducerName}/upsert`>;
  }

  public get remove(): ActionCreatorWithPayload<readonly (number)[], `${ReducerName}/remove`> {
    return this.reducerSlice.actions.remove as ActionCreatorWithPayload<readonly (number)[], `${ReducerName}/remove`>;
  }

  public get selectById(): (state: RootState, id: EntityId) => V {
    return this.entityAdapter.getSelectors((state: RootState) => (this.reducerBase === "optionsState" ? state.optionsState as any : state.graphQlData)[this.slice.name]).selectById;
  }

  public get selectAll(): (state: RootState) => V[] {
    return this.entityAdapter.getSelectors((state: RootState) => (this.reducerBase === "optionsState" ? state.optionsState as any : state.graphQlData)[this.slice.name]).selectAll;
  }

  public get slice(): Slice<EntityState<V, EntityId>> {
    return this.reducerSlice;
  }
}

